import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid2";

export function Card({ item, setSelectedItem, widthPercentage, size }) {
  // console.log("size", size);
  const { i18n } = useTranslation("");
  const {
    id,
    title,
    category,
    color_bg_1,
    color_txt_1,
    description_short,
    bg_image_uuid,
  } = item;
  // return;

  return (
    <Grid
      size={{ xs: 12, sm: size }}
      sx={{
        height: {
          xs: "250px",
          sm: "300px",
          md: "400px",
          lg: "460px",
          xl: "500px",
        },
        backgroundImage: `url(${
          bg_image_uuid?.url
            ? bg_image_uuid.url
            : `/images/pocs_images/${title?.en}.png`
        })`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="card2"
      onClick={() => setSelectedItem(item)}
    >
      <div
        className="card-title-box"
        style={{
          border: "5px solid " + color_bg_1 + "77",
        }}
      >
        <span>{category}</span>
        <h2>{title?.[i18n.language]}</h2>
      </div>
      <div
        style={{
          position: "absolute",
          width: "100%",
          bottom: "0",
          backgroundColor: `${color_bg_1}cc`,
          padding: "1.5rem",
        }}
      >
        {description_short?.[i18n.language]}
      </div>
    </Grid>
  );
}
